import axios from 'axios';
import AutenticationService from '../../authservice.js';

import AccessiService from '../Accessi/AccessiApi.js';
class LuceSrv {
 
  getOpenLuceBasic = (dati) => {
    let BasicAuthHeader =
      //'Basic ' + window.btoa(dati.userid + ':' + dati.password);
      'Basic ' + window.btoa(AutenticationService.getToken());
    const qs = require('qs');

    
    const url = AccessiService.getUrl() + '/luce';
    return axios.post(url, qs.stringify(dati), {
      headers: {
        authorization: BasicAuthHeader,
        token: AutenticationService.getToken(),
      },
    });
  };
}

export default new LuceSrv();
